import React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import ViewImplement from './ViewImplement'
import { deleteImplement, setInitialState } from '../../../actions/resources/ImplementsActions';

export class ImplementsMainComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            add: false,
            edit: false,
            showFilters: false,
            selectedIndex: 0,
            selection: [],
            name: '',
            delete: false,
            favorit: false
        };
    }

    handleClick = () => {
        if (this.state.edit == true && this.state.add == false) {
            this.setState({ edit: false })
        }
        this.setState({ add: !this.state.add }, () => {
            if (this.state.add == true && this.state.edit == false) {
                this.setState({
                    selection: [],
                    name: '',
                })
            };
        });
    };

    onSearchClick() {
        this.setState({ showFilters: !this.state.showFilters });
    }

    handleSelection = (selection, name) => {
        this.setState({
            selection: selection,
            name: name
        })
    }
    
    onEditClick() {
        this.setState({ add: !this.state.add, edit: true });
    }

    onEditFavorit = (ff) => {
        this.setState({ favorit: ff !== undefined ? false : !this.state.favorit })
    }

    onDeleteClick = () => {
        this.setState({ delete: !this.state.delete });
    }

    deleteItem = () => {
        this.props.deleteImplement(this.state.selection, this.state.name);
        this.setState({ delete: false })
    }

    render() {
        const { selection, favorit } = this.state;
        let content;
        content =
            <div className="table-header">
                {/* <Button
                    onClick={() => this.onSearchClick()}
                    variant="fab"
                    color="secondary"
                    aria-label="add"
                    className="action-button"
                >
                    <span className="icon-search headerIcon" />
                </Button> */}
                {selection.length == 1 &&
                    <Button
                        onClick={() => this.onEditFavorit()}
                        variant="fab"
                        color="secondary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-Izmeni1 headerIcon" />
                    </Button>
                }
            </div>
        return (
            <div className="page">
                {content}
                {this.state.selectedIndex === 0 && <ViewImplement favorit={favorit} onEditFavorit={this.onEditFavorit} setSelection={this.handleSelection} edit={this.state.edit} add={this.state.add} showFilters={this.state.showFilters}
                    handleClose={this.handleClick} />}
            </div>
        )
    }

};


function mapStateToProps(state) {
    return {
        deleted: state.implementReducer.deleted,
        deleteImplementFailed: state.implementReducer.deleteImplementFailed,
        implementGroupsPostingSuccess: state.implementReducer.implementGroupsPostingSuccess,
        implementSubgroupsPostingSuccess: state.implementReducer.implementSubgroupsPostingSuccess,
        implementPostingSuccess: state.implementReducer.implementPostingSuccess
    }
}

function mapDispatchToProps(dispatch) {
    return {
        deleteImplement: (selection, name) => dispatch(deleteImplement(selection, name)),
        setInitialState: (component) => dispatch(setInitialState(component)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImplementsMainComponent)